import { InjectionToken } from "@angular/core";

export interface SnomedConfig {
	/** Snowstorm base URL */
	baseUrl: string;
	/** Branch to query (e.g., MAIN, MAIN/SNOMEDCT-XX) */
	branch: string;
	/** Fallback label if nothing is found */
	fallback: string;
}

export const SNOMED_CONFIG = new InjectionToken<SnomedConfig>("SNOMED_CONFIG");
